import { CopyButton } from "../ui/CopyButton";

interface AwsConnectionDetailsCardProps {
  externalId: string;
  assumerRoleArn: string;
  assumingRoleName: string;
}

export function AwsConnectionDetailsCard({
  externalId,
  assumerRoleArn,
  assumingRoleName,
}: AwsConnectionDetailsCardProps) {
  return (
    <div className="p-6 border shadow-lg rounded-2xl bg-background/70 dark:bg-zinc-900/80 backdrop-blur lg:sticky lg:top-24">
      <h2 className="text-lg font-bold mb-4">Connection details</h2>

      {/* External ID */}
      <div>
        <label className="block text-sm font-semibold mb-1">External ID</label>
        <div className="flex items-center gap-2 p-2 bg-gray-50 dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-700">
          <code className="flex-1 text-sm font-mono break-all bg-transparent">
            {externalId}
          </code>
          <CopyButton text={externalId} ariaLabel="Copy External ID" />
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Required in the role's trust policy to prevent confused-deputy
          attacks.
        </p>
      </div>

      <hr className="border-gray-200 dark:border-zinc-700 my-4" />

      {/* Principal to trust */}
      <div>
        <label className="block text-sm font-semibold mb-1">
          Principal to trust
        </label>
        <div className="flex items-center gap-2 p-2 bg-gray-50 dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-700">
          <code className="flex-1 text-sm font-mono break-all bg-transparent">
            {assumerRoleArn}
          </code>
          <CopyButton
            text={assumerRoleArn}
            ariaLabel="Copy principal to trust"
          />
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Allow this principal to assume your role via sts:AssumeRole.
        </p>
      </div>

      <hr className="border-gray-200 dark:border-zinc-700 my-4" />

      {/* Role Name */}
      <div>
        <label className="block text-sm font-semibold mb-1">Role name</label>
        <div className="flex items-center gap-2 p-2 bg-gray-50 dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-700">
          <code className="flex-1 text-sm font-mono bg-transparent">
            {assumingRoleName}
          </code>
          <CopyButton
            text={assumingRoleName}
            ariaLabel="Copy role name"
          />
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          We can only assume this role in your account.
        </p>
      </div>
    </div>
  );
}
